import { j as T } from "./jsx-runtime-3tyXYecC.mjs";
import { f as A } from "./index-LyFokDcn.mjs";
import { T as F, S as N } from "./index-CoZFka0j.mjs";
import { m as R } from "./tss-DN0acMKN.mjs";
import { M as j, d as E } from "./constants-CnFYFetN.mjs";
import { useState as c, useMemo as I, useCallback as h, useEffect as C } from "react";
var u = /* @__PURE__ */ ((e) => (e.InvalidExtension = "INVALID_EXTENSION", e.FileTooLarge = "FILE_TOO_LARGE", e))(u || {});
const _ = [".csv", ".doc", ".docx", ".json", ".pdf", ".rtf", ".txt", ".xls", ".xlsx", ".zip"], k = [".bmp", ".gif", ".jpeg", ".jpg", ".png", ".tif", ".tiff"];
function O(e, t, n) {
  let o;
  switch (t) {
    case u.InvalidExtension: {
      o = window.jQuery ? $.__("The following file types are not allowed: ") : "The following file types are not allowed: ";
      break;
    }
    case u.FileTooLarge: {
      o = window.jQuery ? $.__("The following files are too large: ") : "The following files are too large: ";
      break;
    }
    default:
      o = "";
      break;
  }
  const a = e.errors.findIndex((d) => d.error === t);
  return a === -1 ? e.errors.push({
    error: u.InvalidExtension,
    message: o,
    data: [n]
  }) : e.errors[a].data.includes(n) || e.errors[a].data.push(n), e;
}
const Q = ({
  acceptedTypes: e = [],
  canSelectMultiple: t = !1,
  maxByteSize: n = void 0,
  onFileDrop: o = () => console.error("No handler function provided to useFileDropper"),
  permission: a = !0
}) => {
  const [d, f] = c(0), [L, p] = c(!1), [M, g] = c(), w = () => {
    g(void 0);
  }, y = () => {
    p(!1), f(0);
  }, v = I(
    () => e && e.length ? e.reduce((s, r) => (r === "documents" ? s = [...s, ..._] : r === "images" ? s = [...s, ...k] : s.push(r), s), []) : (
      // If there is no list passed in, or it's empty, default to the full standard list of file types.
      [..._, ...k]
    ),
    [e]
  ), D = h(
    (s, r) => {
      const l = r.name.substr(r.name.lastIndexOf(".")).toLowerCase();
      return v.includes(l) ? n && r.size > n ? O(s, u.FileTooLarge, r.name) : (s.files.push(r), s) : O(s, u.InvalidExtension, l);
    },
    [v, n]
  ), b = h(
    (s) => {
      const { files: r, errors: l } = Object.values(s).reduce(D, { files: [], errors: [] });
      if (l.length) {
        const i = `${l[0].message}${l[0].data.join(", ")}`;
        g({
          message: i,
          onDismiss: w,
          show: !0,
          type: F.error
        });
      }
      r.length && (t ? o(r) : (r.length > 1 && g({
        description: window.jQuery ? $.__(
          "You dragged in multiple files, but only one can be added here. Make sure the file you intended to add got uploaded."
        ) : "You dragged in multiple files, but only one can be added here. Make sure the file you intended to add got uploaded.",
        message: window.jQuery ? $.__("Heads up! Only one file was uploaded, make sure it’s the one you want.") : "Heads up! Only one file was uploaded, make sure it’s the one you want.",
        onDismiss: w,
        show: !0,
        type: F.warning
      }), o([r[0]]))), y();
    },
    [t, o, D]
  ), x = h(
    (s) => {
      s.preventDefault();
      const { files: r } = s.dataTransfer;
      r.length && b(r), y();
    },
    [b]
  ), P = I(() => a ? {
    onDragEnter: (i) => {
      i.dataTransfer.types.includes("Files") && (f((m) => m + 1), i.preventDefault());
    },
    onDragLeave: (i) => {
      i.dataTransfer.types.includes("Files") && (i.preventDefault(), f((m) => m - 1));
    },
    onDragOver: (i) => {
      i.dataTransfer.types.includes("Files") && i.preventDefault();
    },
    onDrop: x
  } : {}, [x, a]);
  return C(() => {
    p(d !== 0);
  }, [d]), { fileDropAttributes: P, isDragging: L, messageProps: M };
}, S = R()(({ borderRadiuses: e, mode: t, palette: n, spacing: o }) => ({
  root: A.ifFeature(
    "encore",
    {
      border: "2px dashed transparent",
      borderRadius: e[300],
      display: "inline-block",
      outline: t === j.Dye ? `2px solid ${E.main}` : void 0,
      padding: o(2)
    },
    {
      border: "3px dashed transparent",
      outline: t === j.Dye ? `2px solid ${E.main}` : void 0,
      padding: o(1)
    }
  ),
  dragging: {
    borderColor: n.info.main
  }
}));
function z({ children: e, ...t }) {
  const { fileDropAttributes: n, isDragging: o, messageProps: a } = Q(t), { classes: d, cx: f } = S();
  return /* @__PURE__ */ T.jsxs(
    "div",
    {
      className: f(d.root, { [d.dragging]: o }),
      "data-fabric-component": "FileDropper",
      ...n,
      children: [
        /* @__PURE__ */ T.jsx(N, { ...a }),
        e
      ]
    }
  );
}
export {
  z as F,
  u as a
};
//# sourceMappingURL=file-dropper-iCPDh7on.mjs.map
